export default "__VITE_ASSET__BphG_2by__"